// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { mountLiveSession } from "./live_session"

function wireCopyButtons() {
  document.querySelectorAll("[data-copy-url-button]").forEach((button) => {
    if (button.dataset.copyBound === "true") return

    button.dataset.copyBound = "true"
    button.addEventListener("click", async () => {
      const input = document.getElementById(button.dataset.copyUrlTarget)
      if (!input) return

      try {
        await navigator.clipboard.writeText(input.value)
      } catch (_error) {
        input.focus()
        input.select()
        document.execCommand("copy")
      }

      const originalLabel = button.textContent
      button.textContent = "Copied"

      window.setTimeout(() => {
        button.textContent = originalLabel
      }, 1500)
    })
  })
}

document.addEventListener("turbo:load", () => {
  wireCopyButtons()
  mountLiveSession()
})
